import { environment } from '../../../environments/environment';
export const auth = {
  msalConfig: {
    auth: {
      clientId: environment.environment.msalConfig.auth.clientId,
      authority: `https://login.microsoftonline.com/${environment.environment.msalConfig.auth.tenantId}`,
      redirectUri: environment.environment.msalConfig.auth.redirectUri,
      postLogoutRedirectUri: environment.environment.msalConfig.auth.redirectUri,
    },
  },
  apiConfig: {
    scopes: [environment.environment.graphApiScope],
    uri: 'https://graph.microsoft.com/v1.0/me',
  },
  loginFailed: '/login-failed',
};

const baseUri = [
  { uri: auth.apiConfig.uri, scope: auth.apiConfig.scopes },
  ...environment.environment.baseUri,
];

export const getProtectedResourceMap = () => {
   const protectedResourceMap = new Map<string, Array<string>>();
    protectedResourceMap.set(environment.environment.baseURL,[]);
    protectedResourceMap.set(environment.environment.graphApiResource, [
    environment.environment.graphApiScope,
  ]);

  baseUri.forEach(({ uri, scope }) => protectedResourceMap.set(uri, scope));
  return protectedResourceMap;
};
